import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../app-configuration';
import { ITspDiaryRepository } from './Itsp-diary.repository';
import { AnomalyLog, ApiResponse, PatientDiaryLog, PatientEventLogsFilter, SearchResult, UpdateAnomalyStatus } from './models';


@Injectable({ providedIn: 'root' })
export class TspDiaryRepository implements ITspDiaryRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);


	patientLastSync(userId: string, patientGuid: string): Observable<ApiResponse<Date | undefined>> {
		const params = new HttpParams().set('userId', userId).set('patientGuid', patientGuid);
		return this.httpClient.get<ApiResponse<Date | undefined>>(this.configs.domainTspAPI + '/api/Diary/PatientLastSync', { params });
	}

	anomalyLogList(userId: string, patientId: string, searchOptions: PatientEventLogsFilter): Observable<ApiResponse<SearchResult<AnomalyLog>>> {
		const params = new HttpParams().set('userId', userId).set('patientId', patientId);
		return this.httpClient.post<ApiResponse<SearchResult<AnomalyLog>>>(this.configs.domainTspAPI + '/api/Diary/AnomalyLogList', searchOptions, { params });
	}

	diaryLogList(userId: string, patientId: string, searchOptions: PatientEventLogsFilter): Observable<ApiResponse<SearchResult<PatientDiaryLog>>> {
		const params = new HttpParams().set('userId', userId).set('patientId', patientId);
		return this.httpClient.post<ApiResponse<SearchResult<PatientDiaryLog>>>(this.configs.domainTspAPI + '/api/Diary/DiaryLogList', searchOptions, { params });
	}

	anomalyReadStatus(itemsToUpdate: UpdateAnomalyStatus[]): Observable<ApiResponse<void>> {
		return this.httpClient.patch<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Diary/AnomalyReadStatus', itemsToUpdate);
	}

}
